import { NotesManagerContent } from "@/features/notes-manager";
import { DEFAULT_NOTE_TYPES } from "@/services/api";
import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { NotesTab as NotesTabMobile } from "@/pages/ContactsPage/Tabs";
import { useNotesManager } from "../model";

export const NotesTab = () => {
  const notesManager = useNotesManager();

  return (
    <ResponsiveBlockSwitcher
      desktop={
        <NotesManagerContent
          notesManager={notesManager}
          noteType={DEFAULT_NOTE_TYPES.DEFAULT_NOTE}
          contactsPage
        />
      }
      mobile={<NotesTabMobile />}
    />
  );
};
